import React from 'react';
import PropTypes from 'prop-types';
import useIsMobile from 'lib/useIsMobile';
import moment from 'moment';

const styles = {
  container: {
    backgroundColor: '#fff1cc',
    display: 'inline-block',
    marginTop: '25px',
    textAlign: 'center',
    width: '390px',
    borderRadius: '10px',
    height: '75px',
    color: 'white',
    marginBottom: '3%',
    border: '2px solid #FFC52F',
  },
  mobileContainer: {
    backgroundColor: '#fff1cc',
    display: 'inline-block',
    marginTop: '25px',
    textAlign: 'center',
    width: '350px',
    borderRadius: '10px',
    height: '75px',
    color: 'white',
    marginBottom: '3%',
    border: '2px solid #FFC52F',
  },
  party: {
    backgroundColor: '#FFC52F',
    width: '80px',
    float: 'left',
    height: '100%',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    fontSize: '26px',
    lineHeight: '22px',
    color: 'white',
    fontWeight: '700',
    fontFamily: 'GaeguBold',
  },
  partyMob: {
    backgroundColor: '#FFC52F',
    width: '80px',
    float: 'left',
    height: '100%',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    fontSize: '24px',
    lineHeight: '22px',
    color: 'white',
    fontWeight: '700',
    fontFamily: 'GaeguBold',
    padding: '3%',
    paddingLeft: '1%',
  },
  col: {
    width: '78%',
    float: 'left',
    height: '100%',
    color: '#080808',
    fontFamily: 'jost',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  count: {
    width: '50px',
    height: '40px',
    borderRadius: '5px',
    backgroundColor: 'white',
    textAlign: 'center',
    fontWeight: '700',
    fontSize: '30px',
    color: '#0076BB',
    marginBottom: '0px',
    fontFamily: 'NiveauGroteskRegular',
  },
  box: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '100%',
    textAlign: 'center',
  },
  leftValue: {
    width: '50px',
    display: 'inherit',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '700',
    fontFamily: 'NiveauGroteskRegular',
    paddingTop: '5%',
  },
  counter: {
    position: 'relative',
    top: '3px',
  },
};

const NextSpotDrop = ({
    eventDetails,
}) => {
  const mobile = useIsMobile();
  const renderTimer = () => {
    return (
      <div style={mobile ? styles.mobileContainer : styles.container}>
        <div style={mobile ? styles.partyMob : styles.party}>
          Next<br />
          spot<br />
          drop
        </div>
        <div style={styles.col}>
          <div style={styles.box}>
            {moment(`${eventDetails?.packAndApplicationCount?.refundPackData?.nextPacksDropDate} 11:00:00`).format('MMMM DD, ha')}{' ET'}
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {moment(eventDetails?.packAndApplicationCount?.refundPackData?.nextPacksDropDate).isValid() && renderTimer()}
    </>
  );
};
NextSpotDrop.propTypes = {
    eventDetails: PropTypes.any,
};

export default NextSpotDrop;
